import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Spinner from "../Spinner";

const AuthLayoutFallback = ({ isLoading, user }) => {
  return isLoading ? (
    <Spinner className="flex justify-center items-center h-screen w-full" />
  ) : !user ? (
    <div className="h-screen w-full relative flex justify-center items-center bg-auth-bg bg-cover">
      {" "}
      <Outlet />
    </div>
  ) : (
    <Navigate to="/" replace />
  );
};

export default AuthLayoutFallback;
